import { Map, List } from 'immutable';
import { createSelector } from 'reselect';
import { getDataSelector } from 'redux/selectors';

export const notificationsCountSelector = type =>
  createSelector(getDataSelector('notifications', type), state =>
    state.reduce((count, n) => (count + n.get('notifications').size), 0));

export const storeNotificationsSelector = sellerId =>
  createSelector(getDataSelector('notifications', 'store'), state =>
    state.find(s => s.get('sellerId') === sellerId, null, Map()).get('notifications', List()));

export const lastNotificationSelector = type =>
  createSelector(getDataSelector('notifications', type), (state) => {
    if (state.size > 0) {
      return state.flatMap(s => s.get('notifications')).maxBy(n => n.get('id'));
    }
    return null;
  });
